import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2, KeyRound } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { isValidPassword, PASSWORD_REQUIREMENTS } from "@/lib/password-policy";

export function ForcePasswordChangeDialog() {
  const { user } = useAuth();
  const { toast } = useToast();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  const mustChange = !!user?.user_metadata?.force_password_change && !done;
  if (!mustChange) return null;

  const handleSave = async () => {
    if (!isValidPassword(password)) {
      toast({
        title: "Senha inválida",
        description: PASSWORD_REQUIREMENTS,
        variant: "destructive",
      });
      return;
    }
    if (password !== confirm) {
      toast({ title: "Senhas não coincidem", variant: "destructive" });
      return;
    }
    setSaving(true);
    const { error } = await supabase.auth.updateUser({
      password,
      data: { force_password_change: false },
    });
    setSaving(false);
    if (error) {
      toast({ title: "Erro ao alterar senha", description: error.message, variant: "destructive" });
      return;
    }
    setDone(true);
    toast({ title: "Senha atualizada!", description: "Bem-vindo(a) à Plateia.Fun." });
  };

  return (
    <Dialog open>
      <DialogContent className="max-w-sm [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <KeyRound size={18} className="text-primary" /> Defina sua nova senha
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Sua conta foi criada com uma senha temporária. Para continuar, use ao menos 8 caracteres, com letra minúscula, maiúscula, número e símbolo.
        </p>
        <div className="space-y-3">
          <Input
            type="password"
            placeholder="Nova senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Input
            type="password"
            placeholder="Confirmar nova senha"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
          <Button variant="wine" className="w-full" disabled={saving} onClick={handleSave}>
            {saving ? <Loader2 className="animate-spin" size={16} /> : "Salvar nova senha"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
